import { Link } from "react-router-dom";
import { faCodeBranch } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Stack, Text } from "@mantine/core";

import { useBasePath } from "@hooks/useBasePath";

export const AddYourCodeUpsell: React.FC<{ incentive: string }> = ({
  incentive,
}) => {
  const basePath = useBasePath();
  return (
    <Stack data-testid="add-your-code">
      <Text align="center">{`Add your own code to ${incentive}!`}</Text>
      <Button
        component={Link}
        leftIcon={<FontAwesomeIcon icon={faCodeBranch} />}
        color="violet"
        to={`${basePath}/projects`}
      >
        Scan project
      </Button>
    </Stack>
  );
};
